// src/utils/helpers.js
export const stringToColor = (str) => {
  if (!str) return "#dddddd";
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += ("00" + value.toString(16)).substr(-2);
  }
  return color;
};

export const customDepartmentSort = (a, b) => {
  const getName = (item) => (typeof item === "string" ? item : item.name);
  const nameA = getName(a);
  const nameB = getName(b);
  const lowerNameA = nameA.toLowerCase();
  const lowerNameB = nameB.toLowerCase();
  const aIsCSuite = lowerNameA.includes("c-suite") || lowerNameA.includes("c suite") || lowerNameA.includes("leadership") || lowerNameA.includes("cxo");
  const bIsCSuite = lowerNameB.includes("c-suite") || lowerNameB.includes("c suite") || lowerNameB.includes("leadership") || lowerNameB.includes("cxo");
  if (aIsCSuite && !bIsCSuite) return -1;
  if (!aIsCSuite && bIsCSuite) return 1;
  if (nameA === "Others") return 1;
  if (nameB === "Others") return -1;
  return nameA.localeCompare(nameB);
};